export const GLOBAL_STATE = 'mail'

export const SEND_MAIL = 'sendMail'
export const EMAIL_TEMPLATE = 'emailTemplate'
export const EMAIL_TEMPLATE_LIST = 'emailTemplateList'
export const EMAIL_TEMPLATE_ALL = 'emailTemplateAll'
export const EMAIL_TEMPLATE_CREATE = 'emailTemplateCreate'
